import { graphql, useStaticQuery } from 'gatsby';
import type { IGatsbyImageData as GatsbyImageData } from 'gatsby-plugin-image';

type Parent = {
  excerpt: string;
};

type Node = {
  parent: Parent;
  title: string;
  slug: string;
  author: string;
  path: string;
  image: {
    sharp: { gatsbyImageData: GatsbyImageData };
  };
  date: string;
};

type Data = {
  allDevlog: {
    nodes: Node[];
  };
};

export type Post = Omit<Node, 'parent'> & Pick<Parent, 'excerpt'>;

export const usePosts = () => {
  const data = useStaticQuery<Data>(graphql`
    query {
      allDevlog(sort: { fields: date, order: DESC }, limit: 3) {
        nodes {
          author
          title
          slug
          date
          path
          image {
            sharp: childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH, aspectRatio: 1)
            }
          }
          parent {
            ... on Mdx {
              excerpt(pruneLength: 110)
            }
          }
        }
      }
    }
  `);

  const posts: Post[] = data.allDevlog.nodes.map(({ parent: { excerpt }, ...fields }) => ({
    excerpt,
    ...fields,
  }));

  return posts;
};
